export default "__VITE_ASSET__t5ayoc3F__"